import React from "react";

import Board from "../components/Board/MissoesBoard";
import Drawer from "../components/Drawer";
import Layout from "~/components/UI/Layout/Layout";
import { LoadingTopBar } from "~/components/UI/LoadingTopBar";

import { BOARD_TYPES } from "../constants";
import { MarketingFiltersContext } from "../filters";
import useMarketingBoard from "../useMarketingBoard";

export const MissoesDomain = () => {
  // Month kept across refreshes (key 'marketing.missoes'); the IndexedDB cache
  // is used only for the current month, in this board's own entry.
  const {
    isLoading,
    setIsLoading,
    date,
    setDate,
    filtersContext,
  } = useMarketingBoard(BOARD_TYPES.MISSOES, { useCache: true });

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <MarketingFiltersContext.Provider value={filtersContext}>
          <Board 
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            date={date}
            setDate={setDate}
          />
        </MarketingFiltersContext.Provider>
        <Drawer />
      </Layout>
    </div>
  );
};

export default MissoesDomain;
